<p-dialog
  [visible]="visible"
  (visibleChange)="visible = $event"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '30rem' }"
  (onHide)="onHide()"
  styleClass="phone-test-dialog"
  contentStyleClass="phone-test-dialog__content">
  <ng-template #header>
    <div class="phone-test-dialog__header">
      <i
        class="pi phone-test-dialog__status-icon"
        [class.pi-spin]="isRunning"
        [class.pi-spinner]="isRunning"
        [class.pi-check-circle]="!isRunning && panelStatus === PanelStatus.Success"
        [class.pi-times-circle]="!isRunning && panelStatus === PanelStatus.Failed"
        [class.phone-test-dialog__status-icon--success]="!isRunning && panelStatus === PanelStatus.Success"
        [class.phone-test-dialog__status-icon--failed]="!isRunning && panelStatus === PanelStatus.Failed">
      </i>
      <div class="phone-test-dialog__header-text">
        <span class="phone-test-dialog__title">{{ panelTitle }}</span>
        @if (phoneNumber) {
          <span class="phone-test-dialog__subtitle">{{ phoneNumber }}</span>
        }
      </div>
    </div>
  </ng-template>

  <div class="phone-test-dialog__times">
    <div class="phone-test-dialog__time-item">
      <span class="phone-test-dialog__time-label">
        {{ 'Settings::PhoneNumbers:StartTime' | abpLocalization }}
      </span>
      <span class="phone-test-dialog__time-value">
        {{ startTime | displayDateTime }}
      </span>
    </div>
    <div class="phone-test-dialog__time-item">
      <span class="phone-test-dialog__time-label">
        {{ 'Settings::PhoneNumbers:ElapsedTime' | abpLocalization }}
      </span>
      <span class="phone-test-dialog__time-value">{{ formattedElapsed }}</span>
    </div>
  </div>

  <div class="phone-test-dialog__steps">
    @for (step of steps; track step.label) {
      <div class="phone-test-dialog__step">
        <div class="phone-test-dialog__step-row">
          <span
            class="phone-test-dialog__step-icon phone-test-dialog__step-icon--{{ step.status }}">
            <i
              class="pi"
              [class.pi-clock]="step.status === TestStepStatus.Pending"
              [class.pi-spin]="step.status === TestStepStatus.InProgress"
              [class.pi-spinner]="step.status === TestStepStatus.InProgress"
              [class.pi-check-circle]="step.status === TestStepStatus.Successful"
              [class.pi-times-circle]="step.status === TestStepStatus.Failed">
            </i>
          </span>
          <span class="phone-test-dialog__step-label">{{ step.label | abpLocalization }}</span>
          <span
            class="phone-test-dialog__step-status phone-test-dialog__step-status--{{ step.status }}">
            @if (step.status === TestStepStatus.Pending) {
              {{ 'Settings::PhoneNumbers:Pending' | abpLocalization }}
            } @else if (step.status === TestStepStatus.InProgress) {
              {{ 'Settings::PhoneNumbers:InProgress' | abpLocalization }}
            } @else if (step.status === TestStepStatus.Successful) {
              {{ 'Settings::PhoneNumbers:Successful' | abpLocalization }}
            } @else {
              {{ 'Settings::PhoneNumbers:Failed' | abpLocalization }}
            }
          </span>
        </div>

        @if (step.status === TestStepStatus.Failed && step.errorMessage) {
          <div class="phone-test-dialog__error">
            <span class="phone-test-dialog__error-label">
              {{ 'Settings::PhoneNumbers:Message' | abpLocalization }}
            </span>
            <span class="phone-test-dialog__error-value">{{ step.errorMessage }}</span>
          </div>
        }
      </div>
    }
  </div>

  <ng-template #footer>
    <button type="button" class="btn btn-sm btn-secondary" (click)="close()">
      {{ 'Settings::PhoneNumbers:Close' | abpLocalization }}
    </button>
  </ng-template>
</p-dialog>
